import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, NgZone, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { NavigationExtras, Router, RouterOutlet } from '@angular/router';
import { ButtonsModule, KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { CellClickEvent, ExcelExportEvent, GridComponent, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, RowClassArgs } from '@progress/kendo-angular-grid';
import { IconsModule, KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { LayoutModule, TabStripModule } from '@progress/kendo-angular-layout';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';


import { checkIcon, cloudIcon, downloadIcon, editAnnotationsIcon, fileExcelIcon, fileIcon, filePdfIcon, imageIcon, infoCircleIcon, pencilIcon, saveIcon, trackChangesAcceptAllIcon, trackChangesAcceptIcon } from '@progress/kendo-svg-icons';
import { DraftsI, ObjectsI, ProjectsI } from '../../_models/projects';
import { ProjectsService } from '../../_services/projects.service';
import { FlatBindingDirective } from '@progress/kendo-angular-treelist';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { UploadService } from '../../_services/upload.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownListModule, DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { UploadFile } from '../../_models/upload_files';
import { FilesService } from '../../_services/files.service';
import { KENDO_NOTIFICATION, NotificationService } from '@progress/kendo-angular-notification';
import { KENDO_PROGRESSBAR, LabelSettings } from '@progress/kendo-angular-progressbar';
import { DownloadService } from '../../_services/download.service';
import { filter, Subject, takeUntil, firstValueFrom, map, tap, forkJoin } from 'rxjs';
import { HttpEventType, HttpHeaderResponse, HttpResponse } from '@angular/common/http';
import { DialogService, DialogsModule, KENDO_WINDOW } from '@progress/kendo-angular-dialog';
import { KENDO_LABELS } from '@progress/kendo-angular-label';
import { formatDate,toDateOrNull } from '../../globals';
import { iconHelper } from '../../../assets/icons/icon-helper';
import { SubjectService } from '../../_services/subject.service';
import { Workbook } from '@progress/kendo-angular-excel-export';
import { saveAs } from '@progress/kendo-file-saver';

@Component({
  selector: 'app-new-submittals',
  imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_GRID_EXCEL_EXPORT, InputsModule,
    LayoutModule, CommonModule, ReactiveFormsModule, DropDownListModule, DropDownsModule, KENDO_PROGRESSBAR, KENDO_WINDOW, KENDO_NOTIFICATION, KENDO_DROPDOWNS, KENDO_LABELS,
    FormsModule, DialogsModule, TabStripModule, IconsModule, ButtonsModule],
  providers: [DatePipe],
  templateUrl: './new-submittals.component.html',
  styleUrl: './new-submittals.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class NewSubmittalsComponent implements OnInit {
  //private iconRegistry = inject(SvgIconRegistryService);

  rowCallback = (context: RowClassArgs) => {
    return context.dataItem.rejected?.length > 0 ? 'rejected-text' : '';
  };

  submittals: DraftsI[] = [];
  selection: any[] = [];
  width = '300';
  svgIcon = [cloudIcon, fileExcelIcon, pencilIcon, downloadIcon, checkIcon, trackChangesAcceptIcon, editAnnotationsIcon, infoCircleIcon, saveIcon];

  copySubmittals: DraftsI[] = [];
  projectId: number = 0;
  objectId: number = 0;
  data = [];
  form!: FormGroup;
  projects: ProjectsI[] = [];
  filteredProjects: ProjectsI[] = [];
  portalObjects: ObjectsI[] = [];
  filteredPortalObjects: ObjectsI[] = [];
  loading1 = false;
  loading2 = false;
  loading3 = false;
  loading4 = false;
  loading5 = false;
  downloadFlag = false;
  status = [true, true];
  selection1: any[] = [];
  selection2: any[] = [];
  selectedUpload: number = -1;
  selectedRowData: any[] = [];
  uploadId: number = 0;
  fileData: UploadFile[] = [];
  fileDataPopUp: UploadFile[] = [];
  accessType = '';
  processed = true;
  flag = true;
  progresstitle: string = 'Download Progress - ';
  actualFileDownloadData: UploadFile[] = [];
  progressmessage: string = '';
  progressValue: number = 0;
  min: number = 0;
  max: number = 100;
  objectName: string = '';
  openedprogresslwindow: boolean = false;
  defaultOrderItem: any;
  private destroy$ = new Subject<void>();
  public label: LabelSettings = {
    visible: true,
    format: "percent",
    position: "end",
  };
  endUrl: string = '';
  statusArr: string[] = [];
  statuses: string[] = ['Pending Acknowledgement', 'Processed', 'Acknowledged', 'Processed with Exceptions', 'Rejected'];
  roleDescription: string = '';
  selectedFileId: number = 0;
  selectedSubItem: any;
  selectedFileItem: any;
  selectedTabIndex: number = 0;
  rejectedRemarksControl = new FormControl('');
  selectedObjectId: number = 0;
  uploadObjStatus: string = '';
  isAdmin: boolean = false;


   @ViewChild(FlatBindingDirective) dataBinding!: FlatBindingDirective;
   @ViewChild('submittalsGrid') submittalsGrid!: GridComponent;
   isExporting = false;

  statusForDownload: string[] = ['Acknowledged', 'Processed', 'Rejected'];
  showRejectDialog = false;
  rejectionRemark = '';
  isRemarkValid: boolean = false;
  showSubmittalsProp: boolean = false;
  showFilesProp: boolean = false


  constructor(private service: ProjectsService, private cdr: ChangeDetectorRef,
    private router: Router, private uploadService: UploadService, private fb: FormBuilder,
    private filesService: FilesService, private notificationService: NotificationService,
    private zone: NgZone, private downloadService: DownloadService, private sub: SubjectService, private dialog: DialogService
  ,private datePipe: DatePipe) {


    /* this.iconRegistry.register([
         { name: 'excel-icon', svg: fileExcelIcon },
         { name: 'pdf-icon', svg: filePdfIcon },
         { name: 'image-icon', svg: imageIcon },
         { name: 'txt-icon', svg: editAnnotationsIcon },
         { name: 'file-icon', svg: fileIcon }
       ]);*/

    this.form = this.fb.group({
      project: {
        projectname: "Select a Project..",
        projectId: null
      },
      purchaseOrder: {
        name: "Select an Order No..",
        id: null
      },
      companyname: null,
      description: null
    });
    this.getProjectsList();
    const currentNavigation = this.router.getCurrentNavigation();
    if (currentNavigation?.extras.state) {
      let url = currentNavigation.extras.state['url'];
      this.data = url?.split('/');
      this.projectId = this.data[0];

      this.objectId = this.data[1];
      this.endUrl = this.data[4];
      if (this.endUrl == 'pending-acknowledgement') {
        this.statusArr.push(this.statuses[0]);
      }
      if (this.endUrl == 'submittals') {
        this.statusArr = this.statuses;
      }
      this.form.patchValue({
        project: {
          projectId: this.data[0],
          projectname: this.data[2],
        },
        purchaseOrder: {
          name: this.data[3],
          id: this.data[1],
        },
        companyname: this.data[5],
        description: this.data[6]
      });
    }

    const cachedUserData = sessionStorage.getItem('userData');
    if (cachedUserData) {
      let userData = JSON.parse(cachedUserData);
      this.isAdmin = userData.usertype === 'A' ? true : false;
    }
    if (this.form.value.project.projectId) {
      this.form.get('purchaseOrder')?.enable();

      sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
      sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));
      sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
      sessionStorage.setItem('poname', JSON.stringify(this.form.value.purchaseOrder.name));
      sessionStorage.setItem('pocompanyName', JSON.stringify(this.form.value.companyname));
      sessionStorage.setItem('podescription', JSON.stringify(this.form.value.description));
      this.getPO();
    } else {
      // this.form.get('purchaseOrder')?.disable();
      
      if (sessionStorage.getItem('projectid')) {
        let pname = JSON.parse(sessionStorage.getItem('projectname') || '');
        let pid = JSON.parse(sessionStorage.getItem('projectid') || '');
        let poname = JSON.parse(sessionStorage.getItem('poname') || sessionStorage.getItem('po-name') || '');
        let poid = JSON.parse(sessionStorage.getItem('poid') || '');
        let poCompanyName = sessionStorage.getItem('pocompanyName') || '';
        let poDescription = sessionStorage.getItem('podescription') || '';
        this.projectId = pid;

        this.objectId = poid;

        console.log("this.objectId",this.objectId,"this.projectId",this.projectId)
        this.form.patchValue({
          project: {
            projectname: pname,
            projectId: pid
          },
          purchaseOrder: {
            name: poname,
            id: poid
          },
          companyname: poCompanyName,
          description: poDescription,
        });
        /*if (sessionStorage.getItem('projectid') && sessionStorage.getItem('poid')) {
          this.getSubmittals();
        }else{*/
          this.getPO();
        //}
       
      } else {
        this.form.get('purchaseOrder')?.disable();
      }
    }
    

  }
  ngOnInit(): void {
    this.sub.refreshTrigger$
      .pipe(
        takeUntil(this.destroy$),
        filter(trigger => trigger === 'submittals')
      )
      .subscribe(() => {
        this.getProjectsList();
        if (this.form.value.project.projectId) {
          
          this.getPO();
        }
        if (this.selectedUpload != -1) {
          this.getFilesForUpload(this.selectedUpload);
        }
        this.cdr.markForCheck();
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPO() {
    this.loading1 = true;
    this.loading2 = true;
    this.loading3 = true;
    this.service.getSubmittalsData(this.form.value.project.projectId).subscribe({
      next: (result) => {
        this.submittals = result.uploads;
        let uploads = result.uploads;
        console.log("this.submittals",this.submittals.length)
        this.portalObjects = result.orders;
        this.filteredPortalObjects = this.portalObjects;
        if (this.endUrl == 'submittals') {
          this.submittals = uploads.filter(obj => obj.status !== 'Draft');
        } if (this.endUrl == 'pending-acknowledgement') {
          this.submittals = uploads.filter(obj => obj.status == 'Pending Acknowledgement');
        } if (this.statusArr.length) {
          this.submittals = uploads.filter(obj => this.statusArr.includes(obj.status));
        } else {
          this.submittals = uploads.filter(obj => obj.status !== 'Draft');
        }
        this.copySubmittals = this.submittals;

        sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
        sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));

        for (var i = 0; i < this.submittals.length; i++) {
          if (this.submittals[i].uploadDate != null) {
            this.submittals[i].uploadDate = new Date(formatDate(this.submittals[i].uploadDate));
          }
          if (this.submittals[i].ackDate != null) {
            this.submittals[i].ackDate = new Date(formatDate(this.submittals[i].ackDate!));
          }
        }

        console.log("this.form.value?.purchaseOrder?.id",this.form.value?.purchaseOrder?.id)
        if (this.form.value?.purchaseOrder?.id) {
          this.submittals = this.submittals.filter(obj => obj.objectId == this.form.value.purchaseOrder.id);

          //get updated company and description for order
          let selectedOrder = this.portalObjects.find(o => o.id == this.form.value.purchaseOrder.id);
          sessionStorage.setItem('pocompanyName', selectedOrder!.companyName);
          sessionStorage.setItem('podescription', selectedOrder!.description);
          this.form.patchValue({ companyname: selectedOrder!.companyName, description: selectedOrder!.description });
        }
        this.loading1 = false;
        this.loading2 = false;
        this.loading3 = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
        this.cdr.markForCheck();
      }

    });
    /*this.service.purchaseOrders(this.form.value.project.projectId).subscribe({
      next: (result) => {
        this.portalObjects = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
      }
    });*/
  }
  navigate(str: string, count: number, dataItem?: any) {
    if (count > 0) {
      if (str == 'upload') {
        sessionStorage.setItem('selected', JSON.stringify(false));
        this.router.navigate(['portal']);
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectname}`
          }
        };
        this.router.navigate(['/purchase-orders'], navigationExtras);
      }
    }
  }
  editUpload(dataItem: any) {
    this.uploadService.getUploadedFiles(dataItem.uploadId).subscribe(res => {
      if (res.length) {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectName}/${dataItem.objectName}/${dataItem.objectId}/${dataItem.uploadId}/${res[0].filename}/${res[0].filesize}`
          }
        };
        this.router.navigate(['/upload'], navigationExtras);
      } else {
        const navigationExtras: NavigationExtras = {
          state: {
            url: `${dataItem.projectId}/${dataItem.projectName}/${dataItem.objectName}/${dataItem.objectId}/${dataItem.uploadId}`
          }
        };
        this.router.navigate(['/upload'], navigationExtras);
      }
    });
  }
  getCount(totalpocount: number, pocount: number) {
    return totalpocount > 0 ? `${pocount} (${totalpocount})` : pocount
  }
  getAllCount(totaluploadcount: number, filecount: number) {
    return filecount > 0 ? `${totaluploadcount} (${filecount})` : totaluploadcount
  }
  getObjectsForProjects(event: any) {
    this.projectId = this.form.value.project.projectId;

    this.loading1 = true;
    this.submittals = [];
    this.fileData = [];
    if (this.form.value.project.projectId) {
      this.form.get('purchaseOrder')?.enable();
      this.form.patchValue({
        purchaseOrder: {
          id: null,
          name: 'Select an Order No..'
        },
        companyname: null,
        description: null
      });
      if (!this.form.value.purchaseOrder.id) {
        this.submittals = [];
        this.copySubmittals = [];
      }
      this.service.getSubmittalsData(+this.form.value.project.projectId).subscribe({
        next: (result) => {
          this.portalObjects = result.orders;
          this.filteredPortalObjects = this.portalObjects;
          // this.copyPurchaseOrders = this.portalObjects;

          /* submittals data code added here */
          this.fileData = [];
          this.submittals = [];
          if (this.endUrl == 'submittals') {
            this.submittals = result.uploads.filter(obj => obj.status !== 'Draft');
          } if (this.endUrl == 'pending-acknowledgement') {
            this.submittals = result.uploads.filter(obj => obj.status == 'Pending Acknowledgement');
          } if (this.statusArr.length) {
            this.submittals = result.uploads.filter(obj => this.statusArr.includes(obj.status));
          } else {
            this.submittals = result.uploads.filter(obj => obj.status !== 'Draft');
          }
          this.copySubmittals = this.submittals;
          sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
          sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));
          sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
          sessionStorage.setItem('poname', JSON.stringify(this.form.value.purchaseOrder.name));
          this.loading3 = false;
          for (var i = 0; i < this.submittals.length; i++) {
            if (this.submittals[i].uploadDate != null) {
              this.submittals[i].uploadDate = new Date(formatDate(this.submittals[i].uploadDate));
            }
            if (this.submittals[i].ackDate != null) {
              this.submittals[i].ackDate = new Date(formatDate(this.submittals[i].ackDate!));
            }
          }

          /*   */

          this.loading1 = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          console.log(error)
        },
        complete: () => {
          for (var i = 0; i < this.portalObjects.length; i++) {
            if (this.portalObjects[i].maxuploaddate != null) {
              this.portalObjects[i].maxuploaddate = new Date(formatDate(this.portalObjects[i].maxuploaddate));
            }
          }
        }

      });
    }
  }

  convertDate(value: Date): Date {
    const dateValue = new Date(value);

    const timezoneOffset = dateValue.getTimezoneOffset(); // Offset in minutes

    const localDate = new Date(dateValue.getTime() + timezoneOffset * 60 * 1000);

    return localDate;
  }
  getSubmittals() {
    
    this.loading3 = true;
    let companyName = this.form.value.purchaseOrder.companyName ? this.form.value.purchaseOrder.companyName :
      this.form.value.companyname ? this.form.value.companyname : sessionStorage.getItem('pocompanyName') ? sessionStorage.getItem('pocompanyName') : '';
    let description = this.form.value.purchaseOrder.description ? this.form.value.purchaseOrder.description :
      this.form.value.description ? this.form.value.description : sessionStorage.getItem('podescription') ? sessionStorage.getItem('podescription') : '';
    this.form.patchValue({ companyname: companyName, description });
    if (this.form.value.project.projectId && this.form.value.purchaseOrder.id) {
      this.projectId = this.form.value.project.projectId;
      this.objectId = this.form.value.purchaseOrder.id;
      this.fileData = [];
      this.submittals = [];
      this.service.draftUploads(this.form.value.project.projectId, this.form.value?.purchaseOrder?.id).subscribe(result => {
        if (this.endUrl == 'submittals') {
          this.submittals = result.filter(obj => obj.status !== 'Draft');
        } if (this.endUrl == 'pending-acknowledgement') {
          this.submittals = result.filter(obj => obj.status == 'Pending Acknowledgement');
        } if (this.statusArr.length) {
          this.submittals = result.filter(obj => this.statusArr.includes(obj.status));
        } else {
          this.submittals = result.filter(obj => obj.status !== 'Draft');
        }

        this.submittals = [...this.submittals];

        this.copySubmittals = this.submittals;
        sessionStorage.setItem('projectid', JSON.stringify(this.form.value.project.projectId));
        sessionStorage.setItem('projectname', JSON.stringify(this.form.value.project.projectname));
        sessionStorage.setItem('poid', JSON.stringify(this.form.value.purchaseOrder.id));
        sessionStorage.setItem('poname', JSON.stringify(this.form.value.purchaseOrder.name));
        sessionStorage.setItem('pocompanyName', companyName);
        sessionStorage.setItem('podescription', description);
        this.loading3 = false;
        for (var i = 0; i < this.submittals.length; i++) {
          if (this.submittals[i].uploadDate != null) {
            this.submittals[i].uploadDate = new Date(formatDate(this.submittals[i].uploadDate));
          }
          if (this.submittals[i].ackDate != null) {
            this.submittals[i].ackDate = new Date(formatDate(this.submittals[i].ackDate!));
          }
          if (this.submittals[i].rejDate != null) {
            this.submittals[i].rejDate = new Date(formatDate(this.submittals[i].rejDate!));
          }
          if (this.submittals[i].procDate != null) {
            this.submittals[i].procDate = new Date(formatDate(this.submittals[i].procDate!));
          }
        }
        this.cdr.detectChanges();
      });
    }
  }
  onValueChange(event: any) {
    this.selection1 = [];
    if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
      this.getSubmittals();
    } else {
      this.getPO();
    }

  }


  onDropdownClose(event: any): void {
    setTimeout(() => {
      this.statusArr = [];
      this.form.get('purchaseOrder')?.reset();
      this.form.get('description')?.reset();
      this.form.get('companyname')?.reset();
      sessionStorage.removeItem('pocompanyName');
      sessionStorage.removeItem('podescription');

      this.defaultOrderItem = { id: null, name: 'Select an Order No..' };

      this.getObjectsForProjects(event);
    })
  }


  getProjectsList() {
    this.loading2 = true;
    this.service.getProjects().subscribe(res => {
      this.projects = res;
      this.filteredProjects = this.projects;
      this.loading2 = false;
      this.cdr.markForCheck();
    });
  }
  backgroundColorStatus(status: string) {
    if (status == 'Processed') {
      return 'rgb(147, 218, 73,0.2)'
    } else if (status == "Pending Acknowledgement") {
      return 'rgb(255, 215, 87,0.2)';
    } else if (status == "Acknowledged") {
      return 'rgb(16, 6, 159,0.2)';
    } else if (status == "ARCHIVED") {
      return 'rgb(186, 186, 186,0.2)';
    } else if (status == "Processed with Exceptions") {
      return 'rgb(147, 218, 73, 0.2)';
    } else if (status == "Rejected") {
      return 'rgba(255, 133, 133, 0.2)';
    } else {
      return '#ff0000'
    }
  }


  getBorder(status: string): string {
    return status === 'Processed with Exceptions'
      ? '4px solid rgb(255, 133, 133, 0.2)' // red outline
      : 'none';
  }

  cellClick(cellclick: CellClickEvent) {

    this.status[0] = cellclick.dataItem.status == 'Pending Acknowledgement' || cellclick.dataItem.status == 'Acknowledged' ? false : true;
    this.status[1] = cellclick.dataItem.status == 'Pending Acknowledgement' ? false : true;
    this.selection2 = [];
    if (cellclick.dataItem.status == 'Processed') {
      this.processed = true;
    } else {
      this.processed = false;
    }
    this.selectedUpload = cellclick.dataItem.uploadId;
    this.accessType = cellclick.dataItem.accessType;
    this.selectedRowData = [];
    this.objectName = cellclick.dataItem.objectName;
    this.selectedObjectId = cellclick.dataItem.objectId;
    this.uploadObjStatus = cellclick.dataItem.status;
    /*if(this.form.value.purchaseOrder.id==null){
     sessionStorage.setItem('poid', JSON.stringify(this.selectedObjectId));
   }*/
    this.getFilesForUpload(cellclick.dataItem.uploadId);
  }

  disableProcessed(dataItem?: any) {
    if (dataItem) {
      console.log("dataItem.acknowledged ",dataItem.acknowledged )
      if(this.isAdmin){ 
        return (dataItem.processed || !dataItem.acknowledged || dataItem.rejected)  
      }else{
        return (this.accessType == 'UPLOAD') || dataItem.processed || !dataItem.acknowledged
        || this.accessType == 'VIEW' || dataItem.rejected;
      }
      
    }
  }

  disableRejected(dataItem?: any) {
    if (dataItem) {
      if(this.isAdmin){ 
        return (dataItem.processed || !dataItem.acknowledged || dataItem.rejected)  
      }else{
        return (this.accessType == 'UPLOAD') || dataItem.processed || !dataItem.acknowledged
        || this.accessType == 'VIEW' || dataItem.rejected;
      }
    }
  }

  disableReset(dataItem?: any) {
    let status = this.submittals.filter(obj => obj.uploadId == this.selection1[0])[0]?.status;
    if(this.isAdmin){
      return (status == 'Processed' || status == 'Rejected' || status == 'Processed with Exceptions'
      || status == 'Pending Acknowledgement' || ((dataItem.status !== 'Processed' || dataItem.status !== 'Rejected') && !this.isAdmin));
    }else{
      return (status == 'Processed' || status == 'Rejected' || status == 'Processed with Exceptions'
      || status == 'Pending Acknowledgement' || ((dataItem.status !== 'Processed' 
        || dataItem.status !== 'Rejected') && this.accessType !== 'PROCESS'));
    }
    
  }

  disableResetAck(): boolean{
    console.log("uploadObjStatus",this.uploadObjStatus,this.isAdmin,this.fileData);
    if(this.isAdmin && this.uploadObjStatus === 'Acknowledged'){
      const flag = this.fileData.every(file =>
       file.acknowledged !== null
      );
      console.log("flag---",flag)
      return flag;
      
    } else{
      return true;
    }
  }

  disableAckUpload(){
    if(this.isAdmin){
      console.log(this.uploadObjStatus);
      return !(this.uploadObjStatus === 'Pending Acknowledgement');
    }else{
      return !(this.uploadObjStatus === 'Pending Acknowledgement' && this.accessType === 'PROCESS');
    }
    
    //return (this.fileData.length == 0 || this.status[1] || this.checkAck() || this.accessType == 'VIEW' || this.accessType =='UPLOAD');
  }

  disableMarkAsProcessed(){
    if(this.isAdmin){
      console.log(this.selectedRowData,!this.checkProcessed(),this.uploadObjStatus,(!this.checkProcessed() && this.uploadObjStatus == 'Acknowledged'))
      return !(!this.checkProcessed() && this.uploadObjStatus == 'Acknowledged')
    }
    return (this.fileData.length == 0 || this.status[0] || this.checkProcessed() || this.processed || this.accessType == 'VIEW' || this.accessType =='UPLOAD');
  }

  isReadOnly(selectedFileItem?: any): boolean {
    return !(this.accessType === 'PROCESS' && this.uploadObjStatus === 'Acknowledged' && this.selectedFileItem.status === 'Rejected');
  }


  downloadCondition(dataItem?: any) {
    if (dataItem) {
      if(this.isAdmin && this.statusForDownload.includes(dataItem.status)){
        return false;
      }else{
        return !(this.accessType == 'PROCESS' && this.statusForDownload.includes(dataItem.status));
      }
    } else {
      const checkFileStatus = this.fileData.length === 0
        ? false
        : this.fileData.length === 1
          ? this.statusForDownload.includes(this.fileData[0].status)
          : this.fileData.every(row => this.statusForDownload.includes(row.status));
      if(this.isAdmin && checkFileStatus){
        return false;
      }else{
        return !(this.accessType == 'PROCESS' && checkFileStatus);
      }
    }
  }
  getFilesForUpload(uploadId: number) {
    this.loading4 = true;
    this.uploadId = uploadId;
    this.fileData = [];
    this.filesService.getFilesForUpload(uploadId).subscribe({
      next: (result) => {
        this.fileData = result;
        console.log("this.fileData",this.fileData)
        this.selectedRowData = this.fileData.filter(obj => obj.file_id == this.selection1[0]);
        this.loading4 = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        this.showError(JSON.stringify(error.message));
        console.log(error)
      },
      complete: () => {
        //this.isLoading = false;
      }
    });
  }
  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }
  condition(str: string, status: string): boolean {
    if (status == 'Draft' && str != 'View' && str != 'Processed' && str != 'Pending Acknowledgement') {
      return true;
    } else if (['Acknowledged', 'Processed', 'Rejected', 'Archived'].includes(status)) {
      return true;
    } else {
      return false;
    }
  }

  resetAcknowledge(){

    this.uploadObjStatus = 'Pending Acknowledgement';
    this.uploadService.resetAcknowledge(this.selectedUpload).subscribe(res => {
      if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
        this.getSubmittals();
      } else {
        this.getPO();
      }
      this.disableAckUpload();
      this.cdr.markForCheck();
    })

  }

  

acknowledge() {

  const objectId = this.form?.value?.purchaseOrder?.id ?? this.selectedObjectId ?? 0;
  this.uploadService.acknowledgeUploadAndFiles(this.selectedUpload, objectId).subscribe(res => {
    if (!this.statusArr.includes('Acknowledged') && this.statusArr.length) {
      this.fileData = [];
      this.selectedRowData = [];
      this.selection1 = [];

    } else {

      this.uploadObjStatus = 'Acknowledged';
      this.getFilesForUpload(this.uploadId);
      this.disableAckUpload();
      this.cdr.markForCheck();
    }

    if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
      this.getSubmittals();
    } else {
      this.getPO();
    }

    this.flag = false;
    this.cdr.markForCheck();
  })
  /*const data = this.fileData.filter(obj => !obj.acknowledged);
  const objectId = this.form?.value?.purchaseOrder?.id ?? this.selectedObjectId ?? 0;

  // If nothing to acknowledge, directly call acknowledgeAllFiles
  if (!data.length) {
    this.callAcknowledgeAllFiles(objectId);
    return;
  }

  const calls = data.map(d =>
    this.uploadService.acknowledge(this.selectedUpload, d.file_id)
  );

  forkJoin(calls).subscribe({
    next: _ => {
      this.callAcknowledgeAllFiles(objectId);
    },
    error: err => {
      // optional: handle errors from any individual acknowledge
      console.error('Acknowledge failed:', err);
      // decide whether to proceed or show error
    }
  });*/
}

private callAcknowledgeAllFiles(objectId: number) {
  this.uploadService.acknowledgeAllFiles(this.selectedUpload, objectId).subscribe(res => {
    console.log("this.statusArr",this.statusArr)
    if (!this.statusArr.includes('Acknowledged') && this.statusArr.length) {
      this.fileData = [];
      this.selectedRowData = [];
      this.selection1 = [];

    } else {

      this.uploadObjStatus = 'Acknowledged';
      this.getFilesForUpload(this.uploadId);
      this.disableAckUpload();
      this.cdr.markForCheck();
    }

    if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
      this.getSubmittals();
    } else {
      this.getPO();
    }

    this.flag = false;
    this.cdr.markForCheck();
  });
}

  /*acknowledge() {
    let data = this.fileData.filter(obj => !obj.acknowledged);
    let i = 0;
    for (i = 0; i < data.length; i++) {
      this.uploadService.acknowledge(this.selectedUpload, data[i].file_id).subscribe(res => {

      });
    }
    if (i == data.length) {

      let objectId = this.form?.value?.purchaseOrder?.id ?? this.selectedObjectId ?? 0;

      this.uploadService.acknowledgeAllFiles(this.selectedUpload, objectId).subscribe(res => {
        // this.selectedRowData.length = 0;
        if (!this.statusArr.includes('Acknowledged') && this.statusArr.length) {
          this.fileData = [];
          this.selectedRowData = [];
          this.selection1 = [];

          //this.getSubmittals();
        } else {
          this.getFilesForUpload(this.uploadId);
          //this.getSubmittals();
        }

        if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
          this.getSubmittals();
        } else {
          this.getPO();
        }


        this.flag = false;
      });

      this.cdr.markForCheck();
    }


    // setTimeout(() => {
    //   this.uploadService.acknowledgeAllFiles(this.selectedUpload, this.form.value.purchaseOrder.id).subscribe(res => {
    //     // this.selectedRowData.length = 0;
    //     if (!this.statusArr.includes('Acknowledged') && this.statusArr.length) {
    //       this.fileData = [];
    //       this.selectedRowData = [];
    //       this.selection1 = [];
    //       this.getSubmittals();
    //     } else {
    //       this.getFilesForUpload(this.uploadId);
    //       this.getSubmittals();
    //     }
    //     this.flag = false;
    //   });

    //   this.cdr.markForCheck();
    // }, 1200);
  }*/
  getAck(): string {
    let data: any[] = this.fileData;
    return data.filter(obj => obj?.file_id == this.selection2[0])[0]?.acknowledged;
  }
  onRowClick(event: any) {
    let rowIndex;
    this.selectedRowData.length ? rowIndex = this.selectedRowData.indexOf(event.dataItem) : rowIndex = -1;
    if (rowIndex > -1) {
      this.selectedRowData.splice(rowIndex, 1);
      this.selection.splice(this.selection.indexOf(event.dataItem.file_id), 1);
    } else {
      if (rowIndex == -1 && this.selection2.length > 1) {
        this.selectedRowData.push(event.dataItem);
        this.selection.push(event.dataItem.file_id);
      }
      if (rowIndex == -1 && this.selection2.length == 1) {
        this.selectedRowData = [];
        this.selectedRowData.push(event.dataItem);
        this.selection.push(event.dataItem.file_id);
      }
    }
    if (this.selectedRowData.length == 1 && !this.selectedRowData[0].acknowledged) {
      this.flag = true;
    } else {
      if (this.selectedRowData.length >= 1) {
        this.selectedRowData.forEach(obj => {
          if (!obj.processed) {
            this.flag = false;
          }
        });
        this.selectedRowData.forEach(obj => {
          if (!obj.acknowledged || obj.processed) {
            this.flag = true;
          }
        });
      }
    }
  }
  getProcessed() {
    const statuses = this.fileData.map(file => file.status);
    const allProcessed = statuses.every(s => s === 'Processed');
    const allRejected = statuses.every(s => s === 'Rejected');

    const statusString = allProcessed
      ? 'Processed'
      : allRejected
        ? 'Rejected'
        : 'Processed with Exceptions';
    let objectId = this.form?.value?.purchaseOrder?.id ?? this.selectedObjectId ?? 0;
    this.uploadService.processAllFiles(this.selectedUpload, objectId, statusString).subscribe(res => {
      console.log("res--->",res)  
      this.uploadObjStatus = res.status;
    });
    for (let i = 0; i < this.fileData.length; i++) {

      // this.getFilesForUpload(this.selectedUpload);
      setTimeout(() => {

        if (this.form.value.project.projectId && this.form.value.purchaseOrder != null && this.form.value.purchaseOrder.id) {
          this.getSubmittals();
        } else {
          this.getPO();
        }
        //this.getSubmittals();
        this.cdr.detectChanges();
        this.processed = true;
        if (!this.statusArr.includes('Processed')
          && !this.statusArr.includes('Processed with Exceptions')
          && !this.statusArr.includes('Rejected')
          && this.statusArr.length) {
          this.fileData = [];
          this.selectedRowData = [];
          this.selection1 = [];
        } else {
          this.getFilesForUpload(this.selectedUpload);
        }
        this.flag = true;
      }, 500);
    }

  }
  processFile(fileId: number) {
    this.loading4 = true;
    this.uploadService.processed(this.selectedUpload, fileId).subscribe(res => {
      this.selectedRowData.length = 0;
      this.getFilesForUpload(this.selectedUpload);
      this.flag = true;
      this.loading4 = false;
    });
  }

  openRejectDialog(fileId: any): void {
    this.selectedFileId = fileId;
    this.rejectionRemark = '';
    this.isRemarkValid = false; // Reset validation
    this.showRejectDialog = true;

  }


  rejectFile(fileId: number) {
    this.showRejectDialog = false;
  }

  resetFileStatus(fileId: number) {
    this.loading4 = true;
    this.uploadService.reset(this.selectedUpload, fileId).subscribe(res => {
      this.selectedRowData.length = 0;
      this.getFilesForUpload(this.selectedUpload);
      this.flag = true;
      this.loading4 = false;
    });

  }

  openPropertiesPopup(dataItem?: any) {
    //this.selectedSubItem = dataItem;
    this.selectedSubItem = {
      ...dataItem,
      
    uploadDate: toDateOrNull(dataItem.uploadDate),
    ackDate:    toDateOrNull(dataItem.ackDate),
    procDate:   toDateOrNull(dataItem.procDate),

    };

    this.uploadId = this.selectedSubItem.uploadId;
    this.fileDataPopUp = [];

    this.filesService.getFilesForUpload(this.uploadId).subscribe({
      next: (result) => {
        this.fileDataPopUp = result;
        this.selectedRowData = this.fileData.filter(obj => obj.file_id == this.selection1[0]);
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        this.showError(JSON.stringify(error.message));
        console.log(error)
      },
      complete: () => {
        if (this.selectedSubItem.uploadDate != null) {
          this.selectedSubItem.uploadDate = formatDate(this.selectedSubItem.uploadDate);
        }

        if (this.selectedSubItem.ackDate != null) {
          this.selectedSubItem.ackDate = formatDate(this.selectedSubItem.ackDate);
        }
        if (this.selectedSubItem.rejDate != null) {
          this.selectedSubItem.rejDate = formatDate(this.selectedSubItem.rejDate);
        }
        if (this.selectedSubItem.procDate != null) {
          this.selectedSubItem.procDate = formatDate(this.selectedSubItem.procDate);
        }
        this.showSubmittalsProp = true;
      }
    });

  }

  closeSubmittalsPropPopup() {
    this.showSubmittalsProp = false;
  }

  openFilePropertiesPopup(dataItem?: any) {
    this.selectedFileItem = dataItem;
    console.log("this.selectedFileItem",this.selectedFileItem)
    if (this.selectedFileItem.upload_date != null) {
      this.selectedFileItem.upload_date = formatDate(this.selectedFileItem.upload_date);
    }
    this.rejectedRemarksControl.setValue(this.selectedFileItem?.rejectedRemarks || '');
    this.showFilesProp = true;
    this.cdr.detectChanges();
  }

  closeFilesPropPopup() {
    this.showFilesProp = false;
  }


  getIcon(fileName: string) {
    return iconHelper.getSvgIconByFileName(fileName);
  }


  updateRejectedRemark(selectedFileItem?: any) {

    const updatedRemark = this.rejectedRemarksControl.value;
    this.selectedFileItem.rejectedRemarks = updatedRemark;
    this.loading5 = true;
    this.uploadService.updateRejectComment(this.selectedFileItem.file_id, this.selectedFileItem.rejectedRemarks).subscribe(res => {
      this.loading5 = false;
    });
  }

  async downloadAllFiles(dataItem?: any) {
    this.progressValue = 0;
    try {
      // Step 1: Show folder picker (this triggers the native prompt later)
      const dirHandle = await (window as any).showDirectoryPicker({ mode: 'readwrite' });

      // Step 2: Create subdirectory
      const directoryHandle = await dirHandle.getDirectoryHandle(
        this.objectName + '_' + this.uploadId.toString(),
        { create: true }
      );

      // Step 3: Show progress window
      this.zone.run(() => {
        this.openedprogresslwindow = true;
        this.cdr.detectChanges();
      });

      // Step 4: Prepare file list
      if (dataItem != undefined) {
        this.actualFileDownloadData = this.fileData.filter(f =>
          f.file_id === dataItem.file_id && f.filename === dataItem.filename
        );
      } else {
        this.actualFileDownloadData = this.fileData;
      }

      let total = this.actualFileDownloadData.reduce((acc, file) => acc + file.filesize, 0);
      let t = total / (1024 * 1024);
      this.progresstitle = 'Download Progress - ' + t.toFixed(2) + ' Mb ';

      let overallTotalDownloadedBytes = 0;
      let overallTotalSize = this.actualFileDownloadData.reduce((sum, file) => sum + file.filesize, 0);
      const downloadedBytesMap = new Map();

      // ✅ Step 5: Check permission explicitly before writing
      const permission = await directoryHandle.queryPermission({ mode: 'readwrite' });
      if (permission !== 'granted') {
        const request = await directoryHandle.requestPermission({ mode: 'readwrite' });
        if (request !== 'granted') {
          // User clicked "Don't Allow"
          this.zone.run(() => {
            this.openedprogresslwindow = false;
            this.showError('Download cancelled. Please Click "Allow" to proceed with downloading files to your device.');
            this.cdr.detectChanges();
          });
          return; // Stop execution
        }
      }

      // ✅ Step 6: Download files
      for (let i = 0; i < this.actualFileDownloadData.length; i++) {
        this.zone.run(() => {
          this.progressmessage = `Preparing to download '${this.actualFileDownloadData[i].filename}' [${i + 1} of ${this.actualFileDownloadData.length}]`;
          this.cdr.detectChanges();
        });

        if (this.projectId == null || this.projectId == 0) {
          this.projectId = JSON.parse(sessionStorage.getItem('projectid') || this.form.value.project.projectId);
        }
        if (this.objectId == null || this.objectId == 0) {
          this.objectId = this.selectedObjectId;
        }

        const encodedFilename = encodeURIComponent(this.actualFileDownloadData[i].filename);
        const downloadObservable = await this.downloadService.downloadAllFiles(
          this.projectId, this.selectedObjectId, this.selectedUpload, this.actualFileDownloadData[i].file_id, encodedFilename
        );

        const response: any = await firstValueFrom(downloadObservable.pipe(
          tap(event => {
            if (event.type === HttpEventType.DownloadProgress) {
              const previousDownloadedBytes = downloadedBytesMap.get(i) || 0;
              const fileDownloadedBytes = event.loaded;
              const newBytes = fileDownloadedBytes - previousDownloadedBytes;
              overallTotalDownloadedBytes += newBytes;
              downloadedBytesMap.set(i, fileDownloadedBytes);
              const overallPercentageString = (overallTotalDownloadedBytes / overallTotalSize * 100).toFixed(2);
              this.progressValue = Math.min(parseFloat(overallPercentageString), 100);
              this.zone.run(() => this.cdr.detectChanges());
            }
          }),
          filter(event => event.type === HttpEventType.Response),
          map(event => event as HttpResponse<any>)
        ));

        let responseFilename = this.getFilenameFromHeader(response);
        if (responseFilename) {
          this.actualFileDownloadData[i].filename = responseFilename;
        }

        let resolvedName = this.actualFileDownloadData[i].filename || '';
        const cd = response.headers?.get('Content-Disposition');
        const headerName = this.parseContentDispositionFilename(cd);

        // If you want to prefer the header's suggestion:
        if (headerName) {
          resolvedName = headerName;
        }

        // If you want to strictly keep the user's original name (as you mentioned):
        // Do NOT overwrite; just keep it for logging / diagnostics.
        // (Comment out the overwrite above if that's your policy.)

        console.log('[DL] Content-Disposition:', cd);
        console.log('[DL] Raw filename candidate:', this.actualFileDownloadData[i].filename);
        console.log('[DL] Parsed header filename:', headerName);
        console.log('[DL] Using resolved filename:', resolvedName);

        // 👉 From here: use resolvedName for the file handle creation.
        // If you must not alter the user’s chosen name "at any cost", use the original:
        // const nameForHandle = this.actualFileDownloadData[i].filename || '';
        
        // 🔧 If it looks percent-encoded, decode it once
        try {
          if (/%[0-9A-Fa-f]{2}/.test(resolvedName)) {
            resolvedName = decodeURIComponent(resolvedName);
          }
        } catch {
          // ignore decode errors; keep as-is
        }

        this.actualFileDownloadData[i].filename = (resolvedName || '').trim();

        // 🔧 Minimal filesystem sanitization (Windows-safe; harmless elsewhere)
        //resolvedName = resolvedName.replace(/[\\/:*?"<>|]/g, '_').trim();

        const nameForHandle = this.actualFileDownloadData[i].filename.replace(/[\\/:*?"<>|]/g, '_');

        const fileHandle = await directoryHandle.getFileHandle(nameForHandle, { create: true });
        await writeFile(fileHandle, response.body);

        this.zone.run(() => {
          this.progressmessage = `Downloaded '${this.actualFileDownloadData[i].filename}' [${i + 1} of ${this.actualFileDownloadData.length}]`;
          this.cdr.detectChanges();
        });
      }

      this.zone.run(() => {
        this.openedprogresslwindow = false;
        this.cdr.detectChanges();
      });

    } catch (error: any) {
      console.error('Error during file download:', error);
      
      if (error?.name === 'AbortError') {
        console.log('User cancelled folder selection');
        return; // silently exit
      }

      if (error.name === 'NotAllowedError') {
        this.zone.run(() => {
          this.openedprogresslwindow = false;
          this.showError('Download cancelled. Please Click "Allow" to proceed with downloading files to your device.');
          this.cdr.detectChanges();
        });
      } else {
        const safeMessage =
        (typeof error === 'string'? error: String(error ?? '')
        ).trim() || 'File name contains invalid characters. Please rename it and try again.';

        this.dialog.open({
          title: 'Info',
          content: safeMessage,
          actions: [{ text: 'OK', themeColor: 'primary' }],
          width: 400,
          height: 200,
          minWidth: 250
        });
        this.zone.run(() => {
          this.openedprogresslwindow = false;
          this.cdr.detectChanges();
        });
      }
    }
  }


  

  parseContentDispositionFilename(
    cdHeader: string | null | undefined
  ): string | undefined {
    if (!cdHeader) return undefined;

    const header = cdHeader.trim();

    
    const fnStarQuoted = header.match(/filename\*\s*=\s*"([^"]+)"/i);
    const fnStarUnquoted = header.match(/filename\*\s*=\s*([^;]+)/i);

    const parseFilenameStar = (match: RegExpMatchArray | null): string | undefined => {
      if (!match) return undefined;
      let value = match[1].trim();

      // Split into charset''encoded
      // Example: UTF-8''my%20file.txt
      const parts = value.split("''");
      if (parts.length === 2) {
        
        const encoded = parts[1];
        try {
          return decodeURIComponent(encoded);
        } catch {
          
          return encoded;
        }
      } else {
        
        try {
          return decodeURIComponent(value);
        } catch {
          return value;
        }
      }
    };

    const starVal = parseFilenameStar(fnStarQuoted) ?? parseFilenameStar(fnStarUnquoted);
    if (starVal) return starVal;

   
    const fnQuoted = header.match(/filename\s*=\s*"([^"]+)"/i);
    if (fnQuoted) {
      const v = fnQuoted[1];
      try {
        return decodeURIComponent(v);
      } catch {
        return v;
      }
    }

    
    const fnUnquoted = header.match(/filename\s*=\s*([^;]+)/i);
    if (fnUnquoted) {
      const v = fnUnquoted[1].trim();
      try {
        return decodeURIComponent(v);
      } catch {
        return v;
      }
    }

   
    return undefined;
  }


  getFilenameFromHeader(v: HttpHeaderResponse): string {
    let responseFilename = ''
    if (v.headers) {
      if (v.headers.has('content-disposition')) {
        const cd = v.headers.get('content-disposition')
        if (cd) {
          const arr = cd.split(';');
          arr.forEach(item => {
            if (item.trim().startsWith('filename')) {
              const item_parts = item.split('=')
              responseFilename = item_parts[1].trim();
              responseFilename = responseFilename.replace(/"/g, '');
              responseFilename = decodeURIComponent(responseFilename);
            }
          })
        }
      }
    }
    return responseFilename
  }
  closeprogresslWindow() {
    this.openedprogresslwindow = false;
  }
  checkProcessed() {
    let status = this.submittals.filter(obj => obj.uploadId == this.selection1[0])[0]?.status;
    if (status == 'Processed') {
      return true;
    } else {
      return this.fileData.filter(obj => (obj.processed == null && obj.rejected == null)).length ? true : false;
    }
  }
  checkAck() {
    return this.fileData.filter(obj => obj.acknowledged == null).length ? false : true;
  }
  getFileName() {
    let str = 'Submittals';
    const projectNumber = this.getProjectNumber();
    if (projectNumber) {
      return `${projectNumber}_${str}_${this.getFormattedDate()}.xlsx`;
    }
    return `${str}_${this.getFormattedDate()}.xlsx`
  }
  getProjectNumber(): string {
    const selected = this.form.value.project;
    if (selected?.projectnumber) {
      return selected.projectnumber;
    }
    const projectId = Number(selected?.projectId ?? this.projectId);
    return this.projects.find(p => p.projectId === projectId)?.projectnumber || '';
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  /*onExcelExport(e: ExcelExportEvent): void {
    const sheet = e.workbook.sheets[0];
    const header = sheet.rows[0];
    const getIndex = (field: string) => header.cells.findIndex((c: any) => c?.value === field);
    const projectId = this.form.value.project.projectId;
    const projectName = this.form.value.project.projectname;
    const orderName = this.form.value.purchaseOrder.name;
    const companyName = this.form.value.companyname;
    const description = this.form.value.description;
    const background = header.cells[0]?.background;
    const color = header.cells[0]?.color;

    const submittalDateCount = getIndex('Submittal Date');
    const acknowledgeDateCount = getIndex('Acknowledged Date');

    this.submittals.forEach((item, i) => {
      const row = sheet.rows[i + 1];
      if (!row || row.type !== 'data') return;

      row.cells[submittalDateCount].value = item.uploadDate ? formatDate(item.uploadDate) : null;
      row.cells[acknowledgeDateCount].value = item.ackDate ? formatDate(item.ackDate) : null;

      row.cells.unshift(
        { value: projectId },
        { value: projectName }
      );
    });

    header.cells.unshift(
      { value: 'Project ID', background, color },
      { value: 'Project Name', background, color },
    )
  }*/

     // The Excel file is built entirely on the backend; filters are passed as query params.
     exportSubmittals(): void {
       const projectId = this.form.value.project?.projectId;
       if (!projectId || this.isExporting) {
         return;
       }

       this.isExporting = true;
       this.cdr.markForCheck();

       const statusParam = this.statusArr && this.statusArr.length > 0 ? this.statusArr.join(',') : '';
       const orderParam = this.form.value.purchaseOrder?.id || null;

       this.service.exportSubmittalsWithFilters(+projectId, statusParam, orderParam).subscribe({
         next: (response: HttpResponse<Blob>) => {
           if (response.body) {
             saveAs(response.body, this.getFileName());
           }

           this.isExporting = false;
           this.cdr.markForCheck();
           this.notificationService.show({
             content: 'Export completed successfully',
             hideAfter: 5000,
             position: { horizontal: "right", vertical: "top" },
             animation: { type: "slide", duration: 400 },
             type: { style: "success", icon: true },
           });
         },
         error: (error) => {
           console.error('Export failed:', error);
           this.isExporting = false;
           this.cdr.markForCheck();
           this.showError('Export failed. Please try again.');
         }
       });
     }

     /* Client-side grid export - replaced by the backend export above.
     private exportGridData(projectId: number): void {
       this.isExporting = true;
       this.cdr.markForCheck();

       this.service.getSubmittalsData(+projectId, true).subscribe({
         next: (result) => {
           const filesByUploadId = new Map<number, UploadFile[]>();
           (result.uploads || []).forEach(u => filesByUploadId.set(u.uploadId, u.files || []));
           this.submittals.forEach(s => s.files = filesByUploadId.get(s.uploadId) || []);
           this.isExporting = false;
           this.cdr.detectChanges();
           this.submittalsGrid.saveAsExcel();
         },
         error: (error) => {
           console.log(error);
           this.isExporting = false;
           this.cdr.markForCheck();
           this.showError('Export failed. Please try again.');
         }
       });
     }

     private exportWithAPI(projectId: number, hasStatusFilter: boolean, hasOrderFilter: boolean): void {
       this.isExporting = true;
       this.cdr.markForCheck();

       // Build status parameter (comma-separated)
       let statusParam = '';
       if (hasStatusFilter) {
         statusParam = this.statusArr.join(',');
       }

       // Build order parameter
       const orderParam = hasOrderFilter ? this.form.value.purchaseOrder.id : null;

       // Call backend API to get filtered Excel file
       this.service.exportSubmittalsWithFilters(projectId, statusParam, orderParam).subscribe({
         next: (blob: Blob) => {
           const fileName = this.generateExportFileName();
           saveAs(blob, fileName);

           this.isExporting = false;
           this.cdr.markForCheck();
           this.notificationService.show({
             content: 'Export completed successfully',
             hideAfter: 5000,
             position: { horizontal: "right", vertical: "top" },
             animation: { type: "slide", duration: 400 },
             type: { style: "success", icon: true },
           });
         },
         error: (error) => {
           console.error('Export failed:', error);
           this.isExporting = false;
           this.cdr.markForCheck();
           this.showError('Export failed. Please try again.');
         }
       });
     }
     */

     /* Filter-aware filename - not used, the export name must stay <projectNumber>_Submittals_<date>.xlsx
     private generateExportFileName(): string {
       let fileName = 'Submittals';
       const projectNumber = this.getProjectNumber();

       if (projectNumber) {
         fileName = `${projectNumber}_${fileName}`;
       }

       // Add order info if filtered by specific order
       if (this.form.value.purchaseOrder?.id) {
         const selectedOrder = this.portalObjects.find(o => o.id === this.form.value.purchaseOrder.id);
         if (selectedOrder && selectedOrder.name) {
           fileName += `_${selectedOrder.name.replace(/[^a-zA-Z0-9_-]/g, '_')}`;
         }
       }

       // Add status info if filtered by status
       if (this.statusArr && this.statusArr.length > 0) {
         const statusStr = this.statusArr.join('_').replace(/\s+/g, '_');
         fileName += `_${statusStr}`;
       }

       fileName += `_${this.getFormattedDate()}.xlsx`;

       return fileName;
     }
     */

    /* Kendo grid Excel export hook - no longer used, the backend builds the file.
    onExcelExport(e: ExcelExportEvent): void {
      const sheet = e.workbook.sheets[0];
      const header = sheet.rows[0];

      const getIndex = (field: string) =>
        header.cells.findIndex((c: any) => c?.value === field);

      const background = header.cells[0]?.background;
      const color = header.cells[0]?.color;

      
      const fileCountIndex = getIndex('File Count');

      if (fileCountIndex !== -1) {
        header.cells.splice(fileCountIndex, 1);

        sheet.rows.forEach((row: any) => {
          if (row.type === 'data') {
            row.cells.splice(fileCountIndex, 1);
          }
        });
      }

      const projectName = this.form.value.project?.projectname || '';

      header.cells.unshift({ value: 'Project Name', background, color });
      sheet.rows.forEach((row: any) => {
        if (row.type === 'data') {
          row.cells.unshift({ value: projectName });
        }
      });


      // Add file columns ONLY (do not disturb existing columns)
      header.cells.push(
        { value: 'Ack Date', background, color },
        { value: 'Ack By', background, color },
        { value: 'Remarks', background, color }
      );
      header.cells.push(
        { value: 'File ID', background, color },
        { value: 'File Name', background, color },
        { value: 'File Size', background, color },
        { value: 'Uploaded Date', background, color },
        { value: 'Uploaded By', background, color },
        { value: 'Handled Date', background, color },
        { value: 'Handled By', background, color },
        { value: 'Rejected Date', background, color },
        { value: 'Rejected By', background, color },
        { value: 'Rejected Remarks', background, color }
      );

      

      // Define fixed widths for all columns
      sheet.columns = header.cells.map((cell: any) => {
        switch (cell.value) {
          case 'Project Name': return { width: 250 };
          case 'Ack Date': return { width: 150 };
          case 'Ack By': return { width: 180 };
          case 'Remarks': return { width: 250 };
          case 'File ID': return { width: 100 };
          case 'File Name': return { width: 250 };
          case 'File Size': return { width: 120 };
          case 'Uploaded Date': return { width: 150 };
          case 'Uploaded By': return { width: 180 };
          case 'Handled Date': return { width: 150 };
          case 'Handled By': return { width: 180 };
          case 'Rejected Date': return { width: 150 };
          case 'Rejected By': return { width: 180 };
          case 'Rejected Remarks': return { width: 250 };
          default: return { autoWidth: true }; // existing columns
        }
      });

      //  Cache indexes (existing + new)
      const projectNameIndex = getIndex('Project Name');
      const submittalDateIndex = getIndex('Submittal Date');

      const ackDateIndex = getIndex('Ack Date');
      const ackByIndex = getIndex('Ack By');
      const remarksIndex = getIndex('Remarks');
      const fileIdIndex = getIndex('File ID');
      const fileNameIndex = getIndex('File Name');
      const fileSizeIndex = getIndex('File Size');
      const uploadedDateIndex = getIndex('Uploaded Date');
      const uploadedByIndex = getIndex('Uploaded By');
      const handledDateIndex = getIndex('Handled Date');
      const handledByIndex = getIndex('Handled By');
      const rejectedDateIndex = getIndex('Rejected Date');
      const rejectedByIndex = getIndex('Rejected By');
      const rejectedRemarksIndex = getIndex('Rejected Remarks');
      const uploadIdIndex = getIndex('Upload ID');
      const orderNoIndex = getIndex('Order No.');
      const orderDescriptionIndex = getIndex('Order Description');
      const companyIndex = getIndex('Company');
      const statusIndex = getIndex('Status');
      

      // Use the exported data rows as style templates, but always expand using the full submittals list.
      const originalDataRows = sheet.rows.filter((row: any) => row?.type === 'data');
      const templateRowByUploadId = new Map<string, any>();

      if (uploadIdIndex !== -1) {
        originalDataRows.forEach((row: any) => {
          const key = String(row.cells?.[uploadIdIndex]?.value ?? '');
          if (key) {
            templateRowByUploadId.set(key, row);
          }
        });
      }

      sheet.rows = [header];

      const newRows: any[] = [];

      this.submittals.forEach((item) => {
        const rowKey = String(item.uploadId ?? '');
        const templateRow = templateRowByUploadId.get(rowKey);

        // Preserve template style when available; otherwise create a blank row matching header length.
        const baseCells = templateRow
          ? templateRow.cells.map((cell: any) => ({ ...cell }))
          : header.cells.map(() => ({ value: '' }));

        if (projectNameIndex !== -1) {
          baseCells[projectNameIndex] = { value: projectName };
        }
        if (uploadIdIndex !== -1) {
          baseCells[uploadIdIndex] = { value: item.uploadId };
        }
        if (orderNoIndex !== -1) {
          baseCells[orderNoIndex] = { value: item.objectName };
        }
        if (orderDescriptionIndex !== -1) {
          baseCells[orderDescriptionIndex] = { value: item.objectDescription };
        }
        if (companyIndex !== -1) {
          baseCells[companyIndex] = { value: (item as any).company || '' };
        }
        if (statusIndex !== -1) {
          baseCells[statusIndex] = { value: item.status };
        }

        //  Fix Submittal Date formatting (keep your old logic)
        if (submittalDateIndex !== -1) {
          baseCells[submittalDateIndex].value =
            item.uploadDate ? formatDate(item.uploadDate) : null;
        }

        
        if (ackDateIndex !== -1) {
          baseCells[ackDateIndex] = {
            value: item.ackDate ? formatDate(item.ackDate) : null
          };
        }

        if (ackByIndex !== -1) {
          baseCells[ackByIndex] = {
            value: item.ackBy || ''
          };
        }

        if (remarksIndex !== -1) {
          baseCells[remarksIndex] = {
            value: item.remarks || ''
          };
        }

        //  MAIN LOGIC: expand rows per file
        const files = Array.isArray(item.files) ? item.files : [];

        if (files.length > 0) {

          files.forEach((file: any) => {

            const rowCells = baseCells.map((c: { value?: any }) => ({ ...c }));


            //  Append file columns
            if (fileIdIndex !== -1) {
              rowCells[fileIdIndex] = { value: file.file_id };
            }
            if (fileNameIndex !== -1) {
              rowCells[fileNameIndex] = { value: file.filename };
            }
            if (fileSizeIndex !== -1) {
              rowCells[fileSizeIndex] = { value: file.filesize_to_display || file.filesize };
            }
            if (uploadedDateIndex !== -1) {
              rowCells[uploadedDateIndex] = {
                value: file.upload_date ? formatDate(file.upload_date) : null
              };
            }
            if (uploadedByIndex !== -1) {
              rowCells[uploadedByIndex] = { value: file.uploaded_by };
            }

            // ✅ handled date logic
            const handledData = file.processed || "";

            let handledDate = "";
            let handledBy = "";

            if (handledData) {
              const parts = handledData.split(" by ");
              handledDate = parts[0] || "";
              handledBy = parts[1] || "";
            }

            if (handledDateIndex !== -1) {
              rowCells[handledDateIndex] = { value: handledDate };
            }
            if (handledByIndex !== -1) {
              rowCells[handledByIndex] = { value: handledBy };
            }

            //  Rejected date logic
            const rejectedData = file.rejected || "";

            let rejectedDate = "";
            let rejectedBy = "";

            if (rejectedData) {
              const parts = rejectedData.split(" by ");
              rejectedDate = parts[0] || "";
              rejectedBy = parts[1] || "";
            }

            if (rejectedDateIndex !== -1) {
              rowCells[rejectedDateIndex] = { value: rejectedDate };
            }
            if (rejectedByIndex !== -1) {
              rowCells[rejectedByIndex] = { value: rejectedBy };
            }

            if (rejectedRemarksIndex !== -1) {
              rowCells[rejectedRemarksIndex] = { value: file.rejectedRemarks };
            }

            newRows.push({
              type: 'data',
              cells: rowCells
            });

          });

        } else {
          // ✅ No files case — still push single row
          newRows.push({
            type: 'data',
            cells: baseCells
          });
        }

      });

      sheet.rows.push(...newRows);
    }
    */

    selectionChange(event: any) {
    
    if (event.accessType === 'VIEW') {
      this.roleDescription = 'View Role';
    }
    if (event.accessType === 'UPLOAD') {
      this.roleDescription = 'Upload Role';
    }
    if (event.accessType === 'PROCESS') {
      this.roleDescription = 'Process Role';
    }
    if (event.accessType === 'ADMIN') {
      this.roleDescription = 'Full Admin';
    }
  }

  onProjectFilter(value: string): void {
    this.filteredProjects = this.projects.filter(p =>
      p.projectname && p.projectname.toLowerCase().includes(value.toLowerCase())
    );

  }

  onOrderFilter(value: string): void {
    this.filteredPortalObjects = this.portalObjects.filter(p =>
      p.name && p.name.toLowerCase().includes(value.toLowerCase())
    );
  }


  onRemarkChange(): void {
    this.isRemarkValid = this.rejectionRemark.trim().length > 0;
  }


  submitRejection(): void {
    this.showRejectDialog = false;
    this.loading4 = true;

    const rejectionData = {
      fileId: this.selectedFileId, // Replace with actual file ID (number)
      rejectRemarks: this.rejectionRemark // Replace with actual remark (string)
    };

    this.uploadService.rejected(this.selectedUpload, rejectionData).subscribe(res => {
      this.selectedRowData.length = 0;
      this.getFilesForUpload(this.selectedUpload);
      this.rejectionRemark = '';
      this.selectedFileId = 0;
      this.flag = true;

      this.loading4 = false;
    });

  }

  cancelRejection(): void {
    this.showRejectDialog = false;
    this.rejectionRemark = '';
  }


  getFileTypeIcon(filename: string | undefined): string {

    if (!filename) return 'file';
    const ext = filename.split('.').pop()?.toLowerCase();
    if (!ext) return 'file';

    if (['jpg', 'jpeg', 'png', 'gif'].includes(ext)) return 'image';
    if (['xls', 'xlsx'].includes(ext)) return 'file-excel';
    if (ext === 'pdf') return 'file-pdf';
    if (ext === 'txt') return 'file-text';

    return 'file';

  }

  
formatDateOrEmpty(value: any, fmt = 'dd-MMM-yyyy'): string {
  console.log("value",value)
  if (!value || value === 0 || value == null) {

    return '';
  }

  const formatted = this.datePipe.transform(value, fmt);
  return formatted ?? ''; // ✅ ensure string
}


  exportToExcel(e: any) {

    const workbook = new Workbook({
      sheets: [
        {
          name: String(this.selectedSubItem?.uploadId || 'Submittal'),

          columns: [
            { width: 130 }, // Column A
            { width: 200 }  // Column B
          ],

          rows: [
            {
              cells: [
                { value: 'Upload ID' },
                { value: this.selectedSubItem?.uploadId }
              ]
            },
            {
              cells: [
                { value: 'Status' },
                { value: this.selectedSubItem?.status }
              ]
            },
            {
              cells: [
                { value: 'Order No' },
                { value: this.selectedSubItem?.objectName }
              ]
            },
            {
              cells: [
                { value: 'Transmittal' },
                { value: this.selectedSubItem?.transmittal }
              ]
            },
            {
              cells: [
                { value: 'Submittal Date' },
                { value: this.selectedSubItem?.uploadDate }
              ]
            },
            {
              cells: [
                { value: 'Acknowledged Date' },
                { value: this.selectedSubItem?.ackDate }
              ]
            },
            {
              cells: [
                { value: 'Processed Date' },
                { value: this.selectedSubItem?.procDate }
              ]
            },
            {
              cells: [
                { value: 'Remarks' },
                { value: this.selectedSubItem?.remarks }
              ]
            },
            {
              cells: [
                { value: 'File Count' },
                { value: this.selectedSubItem?.fileCount }
              ]
            },
            {
              cells: [
                { value: 'Project' },
                { value: this.form.value.project.projectname }
              ]
            },
            {
              cells: [
                { value: 'Order Description' },
                { value: this.selectedSubItem?.objectDescription }
              ]
            },
            {
              cells: [
                { value: 'Company' },
                { value: this.selectedSubItem?.company }
              ]
            },
            {
              cells: [
                { value: 'Submitted By' },
                { value: this.selectedSubItem?.uploadedBy }
              ]
            },
            {
              cells: [
                { value: 'Acknowledged By' },
                { value: this.selectedSubItem?.ackBy }
              ]
            },
            {
              cells: [
                { value: 'Processed By' },
                { value: this.selectedSubItem?.procBy }
              ]
            }
          ]

        },
        {
          name: 'Files',

          columns: [
            { width: 100 }, // File ID
            { width: 250 }, // Filename
            { width: 80 }, // Filesize
            { width: 100 }, // File Upload Date
            { width: 150 }, // Uploaded By
            { width: 100 }, // Handled Date
            { width: 150 }, // Handled By
            { width: 100 }, // Rejected Date
            { width: 150 }, // Rejected By
            { width: 300 }  // Rejection Remarks
          ],
          rows: [
            {
              cells: [
                { value: 'File ID' },
                { value: 'Filename' },
                { value: 'Filesize' },
                { value: 'File Upload Date' },
                { value: 'Uploaded By' },
                { value: 'Handled Date' },
                { value: 'Handled By' },
                { value: 'Rejected Date' },
                { value: 'Rejected By' },
                { value: 'Rejection Remarks' }
              ]
            },
            ...this.fileDataPopUp.map(file => ({
              cells: [
                { value: file.file_id },
                { value: file.filename },
                { value: file.filesize_to_display },
                { value: file.upload_date },
                { value: file.uploaded_by },
                { value: file.processed?.split(' by ')[0] || '' },
                { value: file.processed?.split(' by ')[1] || '' },
                { value: file.rejected?.split(' by ')[0] || '' },
                { value: file.rejected?.split(' by ')[1] || '' },
                { value: file.rejectedRemarks }
              ]
            }))
          ]
        }
      ]
    });


    workbook.toDataURL().then((dataUrl) => {
      const link = document.createElement('a');
      link.href = dataUrl;
      
      // Sanitize filename to prevent injection
      const rawName = `${this.selectedSubItem?.uploadId || 'Submittal'}_${this.selectedSubItem?.uploadDate || 'Date'}`;
      const safeName = rawName.replace(/[^a-zA-Z0-9_\-]/g, ''); // Remove unsafe chars
      link.download = `${safeName}.xlsx`;

      /*const name = this.selectedSubItem?.uploadId + "_" + this.selectedSubItem?.uploadDate + ".xlsx";
      link.download = name;*/
      //document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });


  }




}

async function writeFile(fileHandle: FileSystemFileHandle, contents: any) {
  const writable = await (fileHandle as any).createWritable();
  await writable.write(contents);
  await writable.close();
}
